<template>
  <!--
      	作者：luoyiming
      	时间：2020-06-25
      	描述：插件中心-限时拼团-活动列表-添加活动
      -->
  <div>
    <div class="product-content">
      <el-form size="small" ref="form" :model="form" label-width="150px">
        <!--基础设置-->
        <Basic :form="form" :editType="'add'"></Basic>

        <!--时间设置-->
        <Datetime :form="form"></Datetime>
    
        <!--其它-->
        <Other :form="form"></Other>
      </el-form>
    </div>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import activityApi from '@/api/activity.js';
import Basic from './part/Basic.vue';
import Datetime from './part/Datetime.vue';
import Other from './part/Other.vue';
export default {
  components: {
    /*基础设置*/
    Basic,
    /*时间设置*/
    Datetime,
    /*其它*/
    Other
  },
  data() {
    return {
      form: {
        /*活动名称*/
        title: '',
        /* 活动封面 */
        imgUrl:'',
        /* 活动副标题 */
        subtitle:'',
        /* 内容 */
        content:'',
        route:"",//行程
        notice:"",//须知
        time_bucket:[],//时间段
        iden_num:1,//营员参与最大人数
        refund_type:1,//退款比例
        refund:0,//退款金额
        /*活动时间*/
        active_time: '',
        /*是否生效，默认1为生效，0为不生效*/
        status: 1,
        /*默认排序*/
        sort: 100,
        /*是否免费*/
        is_free:1,
        /*价格*/
        price:0,
        /*是否需要材料*/
        is_data:0,
        categorya:{
          name:"",
          categorya_id:""
        }
      },
      /*判断是否正在加载*/
      loading: false,
    };
  },
  created() {},
  methods: {

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          let params = self.form;
          delete params.tableData;
          //判断退款金额是否超过 活动价格 或者低于0.01
          //退款类型  1  比例  2  固定金额
          if(parseInt(params.refund_type) == 1){
              var act_refund_price = (params.refund/100) * params.price;
          }else if(parseInt(params.refund_type) == 2){
              var act_refund_price = params.refund;
          }
          if(params.is_free == 0){
              if(params.price < 0.01){
              self.$message({
                  message: '活动价格不能低于0.01元',
                  type: 'error'
              });
              return false;
            }

            if(act_refund_price > params.price || act_refund_price < 0.01){
              self.$message({
                  message: '请输入正确的退款金额，不能低于0.01元且不能高于活动价格',
                  type: 'error'
              });
              return false;
            }

          }
         


          self.loading = true;
          activityApi.addActivity(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              self.$router.push('/plus/activity/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/add.vue